'use client'

import { useMemo } from 'react'
import { DesktopFooter, MobileFooter, FooterDataType } from '@quark/footer'
import { NewHomePageComponent } from '@components/HomePage/utils/HomeComponentType'
import { getClassNames } from '@helpers/productWidgetHelper'
import { getIcon } from '@configs/quarkIcons.config'
import { ThemeProvider } from '@quark/theme'
import styles from './footer.module.scss'

export const Footer = ({ data, addBottomPadding = false }) => {
  const footerData: FooterDataType = useMemo(() => {
    if (!data) return {}
    return {
      companyInfo: {
        companyAddress: data?.companyInfo?.companyAddress,
        logoUrl: data?.companyInfo?.logoUrl,
        companyName: data?.companyInfo?.companyName,
        socialNetworkPlatforms: data?.companyInfo?.socialNetworkPlatforms?.map(platform => ({
          logo: getIcon(platform?.logo),
          link: platform?.link,
        })),
      },
      policyInfo: {
        wordings: data?.policyInfo?.wordings,
        logos: data?.policyInfo?.logos?.map(partner => ({
          logo: getIcon(partner?.logo),
          link: partner?.link,
        })),
      },
      categories: data?.categories?.map(category => ({
        categoryName: category?.title,

        ...(category?.options?.length > 0 && {
          options: category?.options?.map(option => ({
            name: option?.title,
            url: option?.desktopUrl,
          })),
        }),

        ...(category?.subCategories?.length > 0 && {
          subCategories: category?.subCategories?.map(subCategory => ({
            subCategoryName: subCategory?.title,
            ...(subCategory?.options?.length > 0 && {
              options: subCategory.options?.map(option => ({
                name: option?.title,
                url: option?.desktopUrl,
              })),
            }),
          })),
        }),
      })),
    }
  }, [data])

  return (
    <ThemeProvider brand="DEFAULT" theme="LIGHT">
      <div
        id={NewHomePageComponent.Footer}
        className={getClassNames([styles.mobileFooter], { [styles.bottomPadding]: !!addBottomPadding })}>
        <MobileFooter footerData={footerData} />
      </div>
      <div
        id={NewHomePageComponent.Footer}
        className={getClassNames([styles.desktopFooter], { [styles.bottomPadding]: !!addBottomPadding })}>
        <DesktopFooter footerData={footerData} />
      </div>
    </ThemeProvider>
  )
}
